  /* ADA (WCAG 2.1.1 / 4.1.2): Sort By – Enter/Space select the focused option.
     Options sit inside the toggle's role="button", so keypresses bubbled up and
     re-activated the current value (Featured). Intercept them in the capture phase. */
  (function () {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var target = e.target;
      if (!target || !target.closest) return;
      var list = target.closest('[id^="SortByListbox"]');
      if (!list) return;
      var item = target.closest('li');
      if (!item) return;

      // Keep the keypress away from the parent toggle button
      e.preventDefault();
      e.stopPropagation();

      var radio = item.querySelector('input[type="radio"]');
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('input', { bubbles: true }));
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Fallback: options rendered as links or plain clickable items
      var link = item.querySelector('a[href]');
      if (link) { link.click(); return; }
      item.click();
    }, true);
  })();

  /* ADA (DEF-022 / WCAG 2.4.3, 2.1.1): Klaviyo "Write a review" dialog
     - moves focus into the dialog when it opens
     - keeps Tab / Shift+Tab inside it
     - Escape closes it
     - returns focus to the "Write a review" button on close */
  (function () {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var trigger = null, dialog = null;

    function isVisible(el) {
      if (!el) return false;
      var s = getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0' && el.getClientRects().length > 0;
    }

    function findDialog() {
      var list = document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog[open], [class*="kl_reviews"][class*="modal"], [class*="klaviyo"][class*="modal"]');
      for (var i = list.length - 1; i >= 0; i--) {
        var el = list[i];
        if (el.closest('#CartDrawer, #SearchDrawer, #MenuDrawer, quick-view')) continue;
        if (isVisible(el) && el.querySelector('input, textarea, button')) return el;
      }
      return null;
    }

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), isVisible);
    }

    function openDialog(el) {
      dialog = el;
      if (!dialog.hasAttribute('role')) dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
        dialog.setAttribute('aria-label', 'Write a review');
      }
      var first = focusables()[0];
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
      (first || dialog).focus();
      watchClose();
    }

    function closeDialog() {
      dialog = null;
      if (trigger && document.contains(trigger)) trigger.focus();
      trigger = null;
    }

    function watchClose() {
      var check = setInterval(function () {
        if (!dialog || !document.contains(dialog) || !isVisible(dialog)) {
          clearInterval(check);
          closeDialog();
        }
      }, 250);
    }

    // 1. Detect the "Write a review" click and wait for the dialog to appear
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button, a, [role="button"]');
      if (!btn || !/write\s+a\s+review/i.test(btn.textContent || btn.getAttribute('aria-label') || '')) return;
      trigger = btn;
      var tries = 0;
      var wait = setInterval(function () {
        var el = findDialog();
        if (el) { clearInterval(wait); openDialog(el); }
        else if (++tries > 40) clearInterval(wait); // give up after ~4s
      }, 100);
    }, true);

    // 2. Trap Tab inside the dialog, Escape closes it
    document.addEventListener('keydown', function (e) {
      if (!dialog) return;
      if (e.key === 'Escape') {
        var close = dialog.querySelector('[aria-label*="lose" i], [class*="close" i], button[title*="lose" i]');
        if (close) { e.preventDefault(); close.click(); }
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    });
  })();

  /* ADA (WCAG 2.1.1 / 4.1.2 / 2.4.7): Wishlist Engine "Add to Wishlist" heart
     - app renders a plain <div> (no role, not focusable, no accessible name)
     - adds role="button", tabindex, product-specific aria-label, aria-pressed
     - Enter/Space trigger the app's own click handler
     - hides decorative icon from screen readers
     - re-applies to cards injected later (filters, sort, infinite scroll) */
  (function () {
    // Focus ring (injected here so no separate <style> tag is needed)
    if (!document.getElementById('ada-wishlist-focus-style')) {
      var css = document.createElement('style');
      css.id = 'ada-wishlist-focus-style';
      css.textContent =
        '.wishlist-engine-button:focus-visible{outline:3px solid #005fcc;outline-offset:2px;box-shadow:0 0 0 5px #fff;}' +
        '@media (forced-colors: active){.wishlist-engine-button:focus-visible{outline-color:Highlight;}}';
      document.head.appendChild(css);
    }

    function getProductName(wrapper) {
      var card = wrapper.closest('.product-card, [role="group"]');
      if (!card) return '';
      var label = card.getAttribute('aria-label') || '';
      // Card label looks like "LPFD15, $49.99" – drop the price part
      label = label.replace(/,\s*[^,]*\d[^,]*$/, '').trim();
      if (label) return label;
      var titleLink = card.querySelector('a[href*="/products/"]');
      return titleLink ? titleLink.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function updateState(wrapper, btn) {
      var name = getProductName(wrapper);
      var added = wrapper.getAttribute('data-added') === 'true';
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      btn.setAttribute('aria-label', name ? 'Add ' + name + ' to wishlist' : 'Add to wishlist');
    }

    function enhance(btn) {
      if (btn.dataset.a11yReady) return;
      var wrapper = btn.closest('.wishlist-engine');
      if (!wrapper) return;
      btn.dataset.a11yReady = 'true';

      // aria-label on a generic div is ignored – move it to the real control
      wrapper.removeAttribute('aria-label');

      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');

      btn.querySelectorAll('svg, .wishlist-icon').forEach(function (el) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('focusable', 'false');
      });

      updateState(wrapper, btn);

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          btn.click();
        }
      });

      // Keep aria-pressed in sync when the app toggles data-added
      new MutationObserver(function () {
        updateState(wrapper, btn);
      }).observe(wrapper, { attributes: true, attributeFilter: ['data-added'] });
    }

    function scan() {
      document
        .querySelectorAll('.wishlist-engine-button:not([data-a11y-ready])')
        .forEach(enhance);
    }

    function init() {
      scan();
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) { scan(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();